
<div class="calling-user-con clearfix">
    <div class="callingFrom fl">
        <img class="portrait" src="{{FromSmallHeadPath}}">    
    </div>
    <img class="status-img" src="../../../public/images/callstatus/calling.png">
    <div class="callingTo fr">
        <img class="portrait" src="{{ToSmallHeadPath}}">
        {{if IsFollow}}
            <span class="has-follow-btn opt-follow-btn">已关注</span>
        {{else}}
            <span class="follow-btn opt-follow-btn">关注</span>
        {{/if}}
    </div>
</div>
<div class="calling-status-text">
    {{if Result==1}}
        <h4 class="calling-text">呼叫中...</h4>
        <h5 class="calling-text-tip">您的手机号为{{FromPhone}}，请注意接听考米<span style="color：#FF5379">{{ShowPhone}}</span>来电。</h5>
    {{else if Result==2 || Result==6}}
        <h4 class="calling-text">正在通话...</h4>
        <h5 class="calling-text-tip">考米语音提倡文明交友、绿色聊天！</h5>
    {{else if Result==3}}
        <h4 class="calling-text">已挂断</h4>
    {{else if Result==4 || Result==5}}
        <h4 class="calling-text" style="color: #FF5379">呼叫失败</h4>
        <h5 class="calling-text-tip">对方暂时无法接听通话，请稍后再拨。</h5>
    {{/if}}
</div>
<div class="btn-wrap" style="padding: 40px;position: absolute;bottom: 0;left: 0;right: 0;text-align: center;">
{{if Result==4 || Result==5}}
    <a class="w360btn gradientColor" id="dail-btn">重新拨打</a>
{{/if}}
</div>